import React, { FC, memo, useCallback, useContext, useEffect, FormEvent } from 'react';
import { ResultContext } from '../../context/result-context';

import Content from '../../components/content';
import Checkbox from '../../components/checkbox';

import {questionContent} from './question-content';
import './question.scss';

interface QuestionProps {
  num: number;
  onClick: (value: number, isRight: boolean) => void;
}

const Question: FC<QuestionProps> = memo(({num, onClick}) => {
  const { currentResult, setCurrentResult } = useContext(ResultContext);

  const data = questionContent[num];

  const handleClick = useCallback(
    (event: FormEvent<HTMLInputElement>) => {
      const value = Number(event.currentTarget.value);
      const isRight = questionContent[num].answers[value].isRight;

      if (!isRight) {
        setCurrentResult(currentResult - 5);
      }

      onClick(value, isRight);
    },
    [num, onClick, currentResult, setCurrentResult]
  );

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  return (
    <div className="question">
      <Content className="-blue" isInner={true}>
        <div className="question__number">{(num + 1)}/10</div>
        <div className="question__result">Интернет-броня: <span>{currentResult}&nbsp;из&nbsp;50</span></div>
        <p className="question__text">{data.text}</p>
        <img src={data.src} alt="" className="question__img" width={data.imgWidth ? data.imgWidth : ''} />
        <p className="question__text">{data.question}</p>
        {data.answers.map((item, index) => (
          <Checkbox
            type="radio"
            name={`q${num}`}
            value={index}
            className="question__answer"
            key={`val${index}`}
            onClick={handleClick}>
              {item.value}
          </Checkbox>
        ))}
      </Content>
	  </div>
  );
});

export default Question;
